module.exports = __webpack_public_path__ + "static/images/flag-cambodia.DjOHRPX.svg";